import { Store } from 'src/store/index';

const getStructure = (store: Store) => store.design.structure;
export default getStructure;
